// src/hooks/useItinerary.ts

import { useContext } from 'react';
import { ItineraryContext } from '../context/ItineraryContext';

export const useItinerary = () => {
  const context = useContext(ItineraryContext);
  if (!context) {
    throw new Error('useItinerary debe ser usado dentro de un ItineraryProvider');
  }
  return context;
};
